export default __webpack_public_path__ + "static/media/atom-i-skybox.597b30b9.svg";